import { createSlice } from '@reduxjs/toolkit';

const initialState = {}

const tokenAuthSlice = createSlice({
    name: 'tokenAuth',
    initialState,
    reducers: {
        guardarToken: (state, action) => {
            const { usuarioId, nombre_completo, rolId, usuario, modulos, token, clienteId, folio, folio_raw, contratoPrestamoId } = action.payload;
            state.usuarioId = usuarioId;
            state.nombre_completo = nombre_completo;
            state.rolId = rolId;
            state.usuario = usuario;
            state.modulos = modulos;
            state.token = token;
            state.clienteId = clienteId;
            state.folio = folio;
            state.folio_raw = folio_raw;
            state.contratoPrestamoId = contratoPrestamoId;
        },
        limpiarToken: (state) => {
            state.usuarioId = '';
            state.nombre_completo = '';
            state.rolId = '';
            state.usuario = '';
            state.modulos = [];
            state.token = '';
            state.clienteId = '';
            state.folio = '';
            state.folioRaw = '';
            state.contratoPrestamoId = '';
        },
    },
});

export const { guardarToken, limpiarToken } = tokenAuthSlice.actions;

export default tokenAuthSlice.reducer;